import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetFernieValuesInUseQueryVariables = Types.Exact<{
  input: Types.FernieValuesInUseInput;
}>;


export type GetFernieValuesInUseQuery = { __typename?: 'Query', fernieValuesInUse: { __typename?: 'FernieValuesInUsePayload', values: Array<{ __typename?: 'FernieValueInUse', id: string, label: string, usageCount: number, usageNoun: string }>, errors?: Array<{ __typename?: 'Error', message: string }> | null } };


export const GetFernieValuesInUseDocument = new TypedDocumentString(`
    query GetFernieValuesInUse($input: FernieValuesInUseInput!) {
  fernieValuesInUse(input: $input) {
    values {
      id
      label
      usageCount
      usageNoun
    }
    errors {
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetFernieValuesInUse: build.query<GetFernieValuesInUseQuery, GetFernieValuesInUseQueryVariables>({
      query: (variables) => ({ document: GetFernieValuesInUseDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetFernieValuesInUseQuery, useLazyGetFernieValuesInUseQuery } = injectedRtkApi;
